import {
    useEffect
} from "react";
import {
    View
} from "react-native";
import stylesheet from "./stylesheet";
import GlobalStateProvider from "./context";
import Navigation from "./navigation";
import OneSignalService from "./services/OneSignalService";
import defaultLocaleJSON from "./variants/locales/default.json";
import defaultThemeJSON from "./variants/themes/default.json";
import {
    androidTypographyFixer,
    NCoreUIKitTheme,
    setupNCoreUIKit
} from "ncore-ui-kit";

const NCoreUIKit = setupNCoreUIKit({
    initialSelectedPalette: "gmcore",
    projectThemes: androidTypographyFixer(defaultThemeJSON),
    initialSelectedTheme: "light",
    projectLocales: defaultLocaleJSON,
    initialSelectedLocale: "tr-TR",
    initialSelectedActiveSharpness: "soft"
});

const ContextAPI = () => {
    const {
        colors
    } = NCoreUIKitTheme.useContext();

    useEffect(() => {
        OneSignalService.initialize();
    }, []);

    return <View
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.content.container.default
            }
        ]}
    >
        <Navigation/>
    </View>;
};

const App = () => {
    return <NCoreUIKit.Provider>
        <GlobalStateProvider>
            <ContextAPI/>
        </GlobalStateProvider>
    </NCoreUIKit.Provider>;
};
export default App;
